import { useEffect, useState } from 'react'

export const useStaySignedIn = () => {
  const [storedEmail, setStoredEmail] = useState('')
  const [storedPhoneNumber, setStoredPhoneNumber] = useState('')

  useEffect(() => {
    const email = localStorage.getItem('_b_s_e')
    const phoneNumber = localStorage.getItem('_b_s_p')

    if (email) {
      setStoredEmail(email)
    }
    if (phoneNumber) {
      setStoredPhoneNumber(phoneNumber)
    }
  }, [])

  const handleStore = (email: string, phoneNumber: string) => {
    localStorage.setItem('_b_s_e', email)
    localStorage.setItem('_b_s_p', phoneNumber)
  }

  return { storedEmail, storedPhoneNumber, storeCredentials: handleStore }
}
